/** The form field under which ASP.NET Core expects the antiforgery token of a POST. */
export const ANTI_FORGERY_TOKEN_NAME = '__RequestVerificationToken';

/** The antiforgery token that the server rendered into a form inside `scope`, or '' without one. */
export function getAntiForgeryToken(scope: ParentNode = document): string {
  const input = scope.querySelector<HTMLInputElement>(`input[name="${ANTI_FORGERY_TOKEN_NAME}"]`);
  return input?.value ?? '';
}
